@if (dataModal) {
  <div class="modal-handle-login-errors-container">
    <h2>{{ dataModal?.texts?.title }}</h2>
    <p [innerHTML]="dataModal?.texts?.content"></p>

    <div class="container-buttons">
      @if (dataModal.hasTwoButtons) {
        <ds-button [text]="'buttons.download' | translate" [styleType]="'default-main'" [width]="'small'" (click)="onAction()"></ds-button>
      }
      <ds-button [text]="dataModal?.texts?.button" [width]="'small'" (click)="onAction()" [styleType]="'default-main'"></ds-button>
    </div>
  </div>
}
